import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  IK_BIED_AAN, AANBOD_VOOR, MATERIALEN,
  MERKEN_PVC, MERKEN_ALU, MERKEN_HOUT, slug,
} from "@/lib/bedrijfOptions";

function Section({ title, children }) {
  return (
    <div className="space-y-3">
      <p className="label-caps border-b border-slate-200 pb-2">{title}</p>
      {children}
    </div>
  );
}

function CheckGroup({ options, values, onToggle, testid, cols = 2 }) {
  const gridCls = cols === 1 ? "grid-cols-1" : "sm:grid-cols-2";
  return (
    <div className={`grid ${gridCls} gap-2`}>
      {options.map((o) => (
        <label key={o} className="flex items-start gap-2.5 cursor-pointer text-sm text-slate-700">
          <input
            type="checkbox"
            data-testid={`${testid}-${slug(o)}`}
            checked={(values || []).includes(o)}
            onChange={() => onToggle(o)}
            className="mt-0.5 w-4 h-4 accent-orange-500 flex-shrink-0"
          />
          <span>{o}</span>
        </label>
      ))}
    </div>
  );
}

export default function BedrijfAanbodFields({ data, onChange }) {
  const upd = (patch) => onChange({ ...data, ...patch });
  const toggle = (key, val) => {
    const arr = data[key] || [];
    upd({ [key]: arr.includes(val) ? arr.filter((x) => x !== val) : [...arr, val] });
  };

  const aanbodVoor = data.aanbod_voor || [];
  const materialen = data.materialen || [];
  const inputCls = "rounded-sm border-slate-300";

  return (
    <div className="space-y-6" data-testid="bedrijf-aanbod-fields">
      <Section title="Ik bied aan">
        <CheckGroup options={IK_BIED_AAN} values={data.ik_bied_aan}
          onToggle={(v) => toggle("ik_bied_aan", v)} testid="bied-aan" cols={1} />
      </Section>

      <Section title="Aanbod is voor">
        <CheckGroup options={AANBOD_VOOR} values={aanbodVoor}
          onToggle={(v) => toggle("aanbod_voor", v)} testid="aanbod-voor" />

        {aanbodVoor.includes("Andere") && (
          <Input data-testid="aanbod-andere-input" value={data.aanbod_andere || ""}
            onChange={(e) => upd({ aanbod_andere: e.target.value })}
            className={inputCls} placeholder="Ander aanbod, omschrijf..." />
        )}

        {aanbodVoor.includes("Ramen en/of deuren") && (
          <div className="mt-4 border-l-2 border-orange-200 pl-4 space-y-5" data-testid="ramen-deuren-detail">
            <div>
              <Label className="text-xs font-bold text-slate-700 mb-2 block">Materialen (ramen en/of deuren)</Label>
              <CheckGroup options={MATERIALEN} values={materialen}
                onToggle={(v) => toggle("materialen", v)} testid="materiaal" />
            </div>

            {materialen.includes("PVC") && (
              <div>
                <Label className="text-xs font-bold text-slate-700 mb-2 block">Merken PVC</Label>
                <CheckGroup options={MERKEN_PVC} values={data.merken_pvc}
                  onToggle={(v) => toggle("merken_pvc", v)} testid="merk-pvc" />
                <Input data-testid="merk-pvc-andere" value={data.merken_pvc_andere || ""}
                  onChange={(e) => upd({ merken_pvc_andere: e.target.value })}
                  className={`${inputCls} mt-2`} placeholder="Ander PVC-merk (optioneel)" />
              </div>
            )}

            {materialen.includes("Aluminium") && (
              <div>
                <Label className="text-xs font-bold text-slate-700 mb-2 block">Merken aluminium</Label>
                <CheckGroup options={MERKEN_ALU} values={data.merken_alu}
                  onToggle={(v) => toggle("merken_alu", v)} testid="merk-alu" />
                <Input data-testid="merk-alu-andere" value={data.merken_alu_andere || ""}
                  onChange={(e) => upd({ merken_alu_andere: e.target.value })}
                  className={`${inputCls} mt-2`} placeholder="Ander aluminium-merk (optioneel)" />
              </div>
            )}

            {materialen.includes("Hout") && (
              <div>
                <Label className="text-xs font-bold text-slate-700 mb-2 block">Houtsoorten / merken</Label>
                <CheckGroup options={MERKEN_HOUT} values={data.merken_hout}
                  onToggle={(v) => toggle("merken_hout", v)} testid="merk-hout" />
                <Input data-testid="merk-hout-andere" value={data.merken_hout_andere || ""}
                  onChange={(e) => upd({ merken_hout_andere: e.target.value })}
                  className={`${inputCls} mt-2`} placeholder="Andere houtsoort (optioneel)" />
              </div>
            )}
          </div>
        )}
      </Section>
    </div>
  );
}
